import { APIModel } from '@shared/interfaces';
import { ImportType } from '@/tax/models/import-type.enum';
import { SingleImportStatus } from '@/tax/models/single-import-status.enum';
import { StatusProvider } from '@/tax/models/status-provider.enum';
import { PersonalTaxFile } from '@/tax/models/personal-tax-file.model';

export class SingleImport implements APIModel {
    id = -1;
    type: ImportType = ImportType.TaxOnWeb;
    status: SingleImportStatus = SingleImportStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    fileName?: string;
    personalTaxFile?: PersonalTaxFile;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.type = data.type ?? ImportType.TaxOnWeb;
        this.status = data.status ?? SingleImportStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.fileName = data.filename;
        this.personalTaxFile = data.personal_tax_file ? new PersonalTaxFile().deserialize(data.personal_tax_file) : undefined;
        if (data.personal_tax_file != undefined) {
            this.personalTaxFile = new PersonalTaxFile().deserialize(data.personal_tax_file);
        }

        return this;
    }
}
